/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="m2.212 13.7938 8.9039 8.8421c.2358.2338.5539.3641.8863.3641.3338 0 .6524-.1308.8868-.3641l8.9042-8.8436c2.9424-2.9222 2.9424-7.6781 0-10.6C19.1284.5455 14.954.2967 12.0026 2.438 9.052.2958 4.8763.5475 2.212 3.1917.786 4.608 0 6.4897 0 8.4927c0 2.002.786 3.8851 2.212 5.3012Zm18.5242-1.0657c2.3518-2.3357 2.3517-6.1362 0-8.4715-2.1327-2.1182-5.485-2.3222-7.8527-.6043l-.8812.6393-.881-.6397C8.7554 1.9342 5.402 2.1395 3.269 4.2561 2.1252 5.3921 1.5 6.8915 1.5 8.4926c0 1.6004.6252 3.101 1.769 4.2369l8.7334 8.6729 8.7338-8.6743ZM16.4352 9.75 13.9559 5.411l-3.5 7L8.9352 9.75H5a.75.75 0 0 0 0 1.5h3.0648l2.4793 4.3388 3.5-7 1.5207 2.6612H19a.75.75 0 0 0 0-1.5h-2.5648Z"
    clipRule="evenodd"
  />,
  'MenuHelthChecks'
);
